import { useContext, useState } from "react"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { Button, Typography } from "@mui/material"
import OneModal from "../../../../../../Components/OneModal/OneModal"
import EventosSelectMultiple from "../../../../../../Components/EventosSelectMultiple/EventosSelectMultiple"
import { WebSocketContext } from "../../../../../../Providers/WebSocket/WebSocketContext"

const EdicaoEventosExcetos = ({ openEventoExceto, setOpenEventoExceto, condEventosExceto, eventosExceto, idCond }) => {
    const { sendWs } = useContext(WebSocketContext)

    const [newValues, setNewValues] = useState([])

    const eventosCondDefault = condEventosExceto.map((evento) => evento.evento)

    const changeEventosExceto = (eventosExceto) => {
        sendWs("editarCondominio", { condominio: { id: idCond, eventos_exceto_hibrida: JSON.stringify(eventosExceto) } })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const newCondEventosExceto = newValues.map((evento) => {
            const eventoAnterior = condEventosExceto.find((ev) => ev.evento == evento.evento)
            if (eventoAnterior) {
                return { evento: evento.evento, porteiro: eventoAnterior.porteiro }
            } else {
                return { evento: evento.evento, porteiro: 0 }
            }
        })
        changeEventosExceto(newCondEventosExceto)
        setOpenEventoExceto(false)
    }

    const handleChange = (events) => {
        setNewValues(events)
    }

    return (
        <OneModal
            open={openEventoExceto}
            setOpen={setOpenEventoExceto}
            titleText={"Eventos para exceção"}
            FooterButtons={FooterButtons}
            fullWidth={true}
            onClose={false}
            maxWidth="sm"
        >
            <form
                id="horario-form"
                onSubmit={handleSubmit}
                style={{ width: '100%' }}
            >
                <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Grid xs={12} md={1.5}>
                        <Typography fontSize="13px" fontWeight='400' >Eventos: </Typography>
                    </Grid>
                    <Grid xs md >
                        <EventosSelectMultiple
                            options={eventosExceto}
                            label="descricao"
                            value="evento"
                            callback={handleChange}
                            defaultValue={eventosCondDefault}
                        />
                    </Grid>
                </Grid>
            </form>
        </OneModal>
    )
}

export default EdicaoEventosExcetos

const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="horario-form" type="submit">Salvar</Button>
        </Grid>
    )
}
